import { useState } from 'react'
import { useApiClient, VisitLogsSearchParams } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export const useVisitLogsExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const doExport = async ({ ...params }: VisitLogsSearchParams) => {
    const queryParams = new URLSearchParams()

    if (params.id) queryParams.append('id', params.id)
    if (params.search) queryParams.append('search', params.search)
    if (params.status) queryParams.append('status', params.status)

    if (params.visitResearchers)
      queryParams.append('researchers', params.visitResearchers)

    if (params.project_leader)
      queryParams.append('project_leader', params.project_leader)

    if (params.isEventApproved !== undefined)
      queryParams.append(
        'is_event_approved',
        params.isEventApproved ? '1' : '0'
      )
    if (params.startDate) queryParams.append('date_start', params.startDate)
    if (params.endDate) queryParams.append('date_end', params.endDate)

    setLoading(true)
    try {
      const response = await client.get<Blob>(
        `/plannings/visit_logs/export/?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { doExport, loading }
}
